export const CREATING_MEMBER = 'Creating Member';
export const RETRIEVING_MEMBERS = 'Retrieving Members';
export const UPDATING_MEMBER = 'Updating Member';
export const DELETING_MEMBER = 'Deleting Member';
export const DOWNLOADING_MEMBER_EXCEL = 'Downloading Member Excel';
export const RETRIEVING_TRIBE_MEMBERS = 'Retrieving Tribe Members';
export const RETRIEVING_MEMBER = 'Retrieving Member';
export const RETRIEVING_MEMBER_PROFILE = 'Retrieving Member Profile';
